<!--
 * @Description: 登录页面
 * @Date: 2022-01-20 15:18:47
 * @LastEditTime: 2022-01-27 17:41:57
-->
<template lang="pug">
  div.login-container
    comp-login-card(@loginSuccess="handleLoginSuccess")
</template>

<script>
import compLoginCard from './components/login-card';
import Cookies from 'js-cookie';
import { goToPage } from 'utils/common.js';
import {
  tokenLogin,
} from '@/api/http';
export default {
  name: 'login',
  data() {
    return {
    };
  },
  components: {
    compLoginCard,
  },
  methods: {
    handleLoginSuccess() {
      goToPage('live-list');
    },
  },
  async beforeCreate() {
    const userInfo = JSON.parse(localStorage.getItem('trtc-tuiPlayer-userInfo'));
    const userId = userInfo && userInfo.userId;
    const token = Cookies.get('trtc-tuiPlayer-token');
    if (!userId || !token) {
      return;
    }
    const result = await tokenLogin({ userId, token });
    if (result.errorCode === 0) {
      const { sdkAppId, sdkUserSig, userId, token, name, avatar } = result.data;
      const userInfo = JSON.stringify({
        sdkAppId,
        userSig: sdkUserSig,
        userId,
        userName: name,
        userAvatar: avatar,
      });
      localStorage.setItem('trtc-tuiPlayer-userInfo', userInfo);
      Cookies.set('trtc-tuiPlayer-token', token, { expires: 30 });
      goToPage('live-list');
    }
  },
};
</script>

<style lang="stylus" scoped>
.login-container
  width 100%
  height 100%
  position relative
  display flex
  justify-content center
  align-items center
</style>
